// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__rIIN0","title":"BackImages_title__fv6fS","images":"BackImages_images__j3rwS"};